'use client';
import { useEffect, useContext } from 'react';
import { BootstrapContext } from '@/pagesComponents/Layout';

const UserInitials = ({ userInitials = 'XX', userName = '' }) => {
  const bootstrap = useContext(BootstrapContext);
  useEffect(() => {
    setTimeout(() => {
      var tooltipTriggerList = [].slice.call(
        document.querySelectorAll('[data-bs-toggle="tooltip"]')
      );
      var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl);
      });
    }, 100);
  }, []);

  return (
    <span
      className={
        'rounded rounded-circle bg-secondary text-light fw-bold fs-4 py-1 px-2'
      }
      data-bs-toggle="tooltip"
      data-bs-placement="bottom"
      title={userName}
    >
      {userInitials}
    </span>
  );
};

export default UserInitials;
